//import React components
import PropTypes from "prop-types";
import {Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button} from "reactstrap";
import CloseIcon from "@mui/icons-material/Close";

//import components


//Props settings for CustomModal
CustomModal.propTypes = {
    header: PropTypes.array,
    footer: PropTypes.array,
    body: PropTypes.array,
    isOpen: PropTypes.bool,
    setOpen: PropTypes.func
}

CustomModal.defaultProps = {

}

export default function CustomModal ({header, footer, body, isOpen, setOpen, ...props}) {
    return (
        <>
            <Modal isOpen={isOpen} {...props}>
                <Row className={"modal_topbar"}>
                    <Col className={"modalTop_main"}>
                        {header && (
                            <ModalHeader>
                                {header}
                            </ModalHeader>
                        )}
                    </Col>
                    <Col className={"modalTop_close"} xs={"auto"}>
                        <Button title={"Lukk"} color={"black"} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </Button>
                    </Col>
                </Row>
                {body && (
                    <ModalBody>
                        {body}
                    </ModalBody>
                )}
                {footer && (
                    <ModalFooter>
                        {footer}
                    </ModalFooter>
                )}
                {props.children}
            </Modal>
        </>
    )
}
